import { Navigate } from 'react-router-dom';

/**
 * A route that only sends the reader on (`/` to the app's home, `/-/new` to a new item, an old or
 * moved address to its new one), replacing the address unless it is told to `push`, with the
 * navigation state it is given.
 *
 * I-2056: React Router navigates in a transition, so while the target's route chunk is still read
 * React keeps this route drawn. A bare `<Navigate>` draws nothing, and the launch wait settled over
 * that empty page and faded before the list arrived, whose skeleton then drew after it (LS-2). The
 * route-pending marker says the page is still coming (`isContentPending`, `whenScreenSettles`). It
 * has no size, so nothing moves when the page replaces it.
 *
 * LS-8: every redirect in the app is this one, so each says its page is still coming
 * (`routeRedirect.guard.test.ts`).
 */
export function RouteRedirect({
  to,
  state,
  push = false,
}: {
  to: string;
  state?: unknown;
  /** Keep the address it leaves in the history, for a redirect the reader asked for. */
  push?: boolean;
}) {
  return (
    <>
      <Navigate to={to} state={state} replace={!push} />
      <div data-route-pending="" />
    </>
  );
}
